export default {
  userObject: state => {
    return state.auth.userObject;
  },
  subjectSelectedCase: state => {
    return state.subjectSelectedCase;
  },
  content: (state) => {
    return state.config.contentTranslations;
  },
  authenticated: state => {
    return state.auth.authenticated;
  },
  currentCalendarRange: state => {
    return state.appointmentsCalendarPage.currentCalendarRange;
  },
  getPatientCase: state => {
    return state.intakeFormData.patientCase;
  },
  locations: state => {
    return state.appointmentsCalendarPage.locations;
  },
  location: state => {
    return state.appointmentsCalendarPage.location;
  }
};